import { render, staticRenderFns } from "./ComboboxBoolean.vue?vue&type=template&id=5da9e2c2&scoped=true&"
import script from "./ComboboxBoolean.vue?vue&type=script&lang=js&"
export * from "./ComboboxBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da9e2c2",
  null
  
)

export default component.exports